import VodafoneImage from "images/devices/vodafone.png"

export const Vodafone = {
  id: "VODAFONE_ROUTER",
  img: VodafoneImage,
  name: "Vodafone Router",
  rating: 5,
  availableColors: ["black"],
  details: {}
}
